<template src="./html/Datatable.html"></template>

<script>
	import Fab from './Fab'
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
	import FilterBar from './FilterBar'
	import ProjectsMap from './ProjectsMap'
	import Actions from './Actions'
	import VueElementLoading from 'vue-element-loading'
	import ChangeStatus from './ChangeStatus'

	import _ from 'lodash'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'fab': Fab,
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,
			'filter-bar': FilterBar,
			'projects-map': ProjectsMap,
			'actions': Actions,
			'loading': VueElementLoading,
			'change-status': ChangeStatus,
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/projects/projects/datatable',
					loading: true,
					moreParams: {
						filter: {
							allowDate: false,
							status: null,
							date: null,
							text: null,
							project_status_id: null,
							author_id: null,
						}
					},
					page: 20,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: '__slot:id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
						},
						{
							name: '__slot:projects_name',
							title: 'Nombre',
							sortField: 'name',
						},
						{
							name: '__slot:projects_team',
							title: 'Equipo',
							sortField: 'team_id',
						},
						{
							name: '__slot:projects_user',
							title: 'Coordinador',
							sortField: 'user_id',
						},
						{
							name: '__slot:statuses',
							title: 'Estado',
							sortField: 'project_status_id',
						},
						{
							name: '__slot:projects_customers',
							title: 'Clientes',
						},
						{
							name: '__slot:projects_author',
							title: 'Autor',
							sortField: 'author_id',
						},
						{
							name: 'created_at',
							title: 'Fecha',
							sortField: 'created_at',
							callback: function(value) {
								return moment(value).format('DD/MM/YY')
							},
						},
						{
							name: '__slot:projects_actions',
							title: '',
						},
					],
				},
				projects: null,
				statuses: null,
			}
		},
		watch: {
			'$route.params.status': function(value) {
				if(value) {
					this.datatable.moreParams.filter.status = value
				} else {
					this.datatable.moreParams.filter.status = null
				}
				this.$nextTick( () => this.$refs.datatable.normalizeFields())
				this.$nextTick( () => this.$refs.datatable.refresh())

				this.getProjects()
			},
		},
		created() {
			if(this.$route.params.status) {
				this.datatable.moreParams.filter.status = this.$route.params.status
			}

			this.init()
		},
		mounted() {
			this.$events.$on('filterSet', eventData => this.filterSet(eventData))
			this.$events.$on('filterReset', eventData => this.filterReset(eventData))
		},
		methods: {
			init() {
				//this.getProjects()
				this.loadQuery()
				this.getStatuses()
			},
			loadQuery() {
				if(this.$route.query) {
					if(this.$route.query.text) {
						this.datatable.moreParams.filter.text = this.$route.query.text
					}
					if(this.$route.query.date) {
						this.datatable.moreParams.filter.allowDate = true
						this.datatable.moreParams.filter.date = this.$route.query.date
					}
				}
			},
			getStatuses() {
				this.$http.get('admin/projects/projects/statuses')
					.then(response => {
						this.statuses = response.body
					})
			},
			/*
			getProjects() {
				if(this.$route.params.status) {
					var api = 'admin/projects/projects/status/' + this.$route.params.status
				} else {
					var api = 'admin/projects/projects'
				}
				this.$http.get(api)
				.then(response => {
					this.projects = response.body
				})
			},
			*/
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
				this.loadDropdowns()
			},
			success(response) {
				this.projects = response.data.data
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet: _.debounce(function (filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			}, 300),
			filterReset(filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			},
			//--
			openCreateSchedule(item) {
				this.$refs.schedulecreate.item = item
				this.$refs.schedulecreate.open()
			},
			openTaskCreate(data) {
				this.$refs.taskCreate.open(data)
			},
			//--
			loadDropdowns() {
				$('.table-responsive').on('show.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "inherit" )
				});

				$('.table-responsive').on('hide.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "auto" )
				})
			},
			destroy(project) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/projects/projects/' + project.id)
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			openMap() {
				this.$refs.projectsMap.open()
			}
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/projects/projects/views/Datatable.vue